import { useCallback } from 'react';

export default function useClipboard() {
  const copy = useCallback((str: string) => {
    return navigator.clipboard.writeText(str);
  }, []);
  return copy;
}
